import { render, staticRenderFns } from "./CellDisplayLabel.vue?vue&type=template&id=f5bb1dca&"
import script from "./CellDisplayLabel.vue?vue&type=script&lang=js&"
export * from "./CellDisplayLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports